import AgoraRTMPPlayerComponent from "./AgoraRTMPPlayerComponent";

export default AgoraRTMPPlayerComponent;
